module.exports = __webpack_public_path__ + "bccb948410ca85a1102a7f30ed6373dc.svg";